/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DismissOktaServerSuggestionRequestBody = {
  /**
   * Catalog entry of the suggestion to dismiss.
   */
  registryEntryId: string;
};

/** @internal */
export type DismissOktaServerSuggestionRequestBody$Outbound = {
  registry_entry_id: string;
};

/** @internal */
export const DismissOktaServerSuggestionRequestBody$outboundSchema:
  z.ZodMiniType<
    DismissOktaServerSuggestionRequestBody$Outbound,
    DismissOktaServerSuggestionRequestBody
  > = z.pipe(
    z.object({
      registryEntryId: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        registryEntryId: "registry_entry_id",
      });
    }),
  );

export function dismissOktaServerSuggestionRequestBodyToJSON(
  dismissOktaServerSuggestionRequestBody:
    DismissOktaServerSuggestionRequestBody,
): string {
  return JSON.stringify(
    DismissOktaServerSuggestionRequestBody$outboundSchema.parse(
      dismissOktaServerSuggestionRequestBody,
    ),
  );
}
